import React, { FC, useContext } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { matchActiveTicketsToggle } from './handlers';
import ToggleBtn from '../ToggleBtn';
import { expandedMatchTickets$$, matchActiveTickets$$, matchTicketsVisible$$ } from './subs';
import { activeCashin$$ } from '../cashin/subs';
import { cashinSportEventToggle } from '../cashin/handlers';
import TurboLiveContext from '../../context/TurboLiveContext';
import { useTicketsForBets } from './hooks/useTicketsForBets';
import { setActiveTicketsTab } from '../../handlers';
import { isMobileChannel } from '../../../../common/util';
import { CashinPosition } from '../cashin/constants';
import CashinPositionContext from '../../../../common/CashinPositionContext';

export const TicketsListMatchToggle: FC<{ matchId: string; isOverview?; usePlaceholder?: boolean }> = ({
    matchId,
    isOverview,
    usePlaceholder
}) => {
    const derefSub = useReframe();
    const matchTickets = derefSub(matchActiveTickets$$(matchId));
    const activeCashin = derefSub(activeCashin$$(matchId));
    const activeTickets = derefSub(expandedMatchTickets$$(matchId));
    if (!matchTickets.size) {
        return usePlaceholder ? <span className="px-2 py-8" /> : null;
    }
    const active = activeTickets && !activeCashin && isOverview;
    const onClick = e => {
        if (!isMobileChannel()) {
            if (!isOverview) {
                dispatch(setActiveTicketsTab);
            } else {
                if (activeCashin) {
                    dispatch(cashinSportEventToggle(matchId));
                }
                if (!activeTickets || !activeCashin) {
                    dispatch(matchActiveTicketsToggle(matchId));
                }
            }
        }
        e.preventDefault();
        e.stopPropagation();
    };
    return (
        <ToggleBtn
            imgId="live-tickets"
            titleKey="nui.turbo.live.icon.tickets"
            onClick={onClick}
            active={active}
            badge={matchTickets.size}
        />
    );
};

export const TicketsMatchCollapsible: FC<{ matchId: string }> = ({ matchId }) => {
    const derefSub = useReframe();
    const { ticketsTable } = useContext(TurboLiveContext);
    const activeCashin = derefSub(activeCashin$$(matchId));
    const activeTickets = derefSub(matchTicketsVisible$$(matchId));
    return !activeTickets || activeCashin ? null : (
        <CashinPositionContext.Provider value={{ cashinPosition: CashinPosition.LIVE_OVERVIEW_TICKET_LIST }}>
            <div className="br-b-default-light">{ticketsTable(matchId, 'turbo-live-overview')}</div>
        </CashinPositionContext.Provider>
    );
};

export const TicketDetailMarket: FC<{ betIds: any }> = ({ betIds }) => {
    const betOnTickets = useTicketsForBets(betIds);
    if (!betIds?.size || !betOnTickets?.size) {
        return null;
    }
    const onClick = e => {
        if (!isMobileChannel()) {
            dispatch(setActiveTicketsTab);
        }
        e.preventDefault();
        e.stopPropagation();
    };
    return (
        <ToggleBtn
            imgId="live-tickets"
            titleKey="nui.turbo.live.icon.tickets"
            data-atid="ticket-detail-market-toggle-button"
            onClick={onClick}
            active={false}
            badge={betOnTickets.size}
            otherClass="py-5"
        />
    );
};
